import {
  put,
  fork,
  call,
  takeLatest,
  takeEvery,
  all,
  select,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadMemberInfoCompletion,
  loadAgentInfoCompletion,
  applyAgentCompletion,
  upgradeToAgentCompletion,
  loadAgentInvoiceProxyRecordCompletion,
  loadConsumeHistoryCompletion,
  saveAgentESignEditCompletion,
  catchError,
} from '../../actions';

export function* watchLoadMemberInfo() {
  yield takeEvery('LOAD_MEMBER_INFO', function*() {
    const options = {
      url: '/api/performance/reward/index',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadMemberInfoCompletion(result.error, result.data));
  });
}

export function* watchLoadAgentInfo() {
  yield takeLatest('LOAD_AGENT_INFO', function*() {
    const options = {
      url: '/api/user/myinfo',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadAgentInfoCompletion(result.error, result.data));
  });
}

export function* watchApplyAgent() {
  yield takeLatest('APPLY_AGENT', function*() {
    const { realName, wechat } = yield select(
      state => state.member.agent.info.input
    );
    let error;

    if (!realName) {
      error = new Error('请输入真实姓名');
    } else if (!wechat) {
      error = new Error('请输入微信号');
    } else if (!/^[A-Za-z][\w-]{5,19}$/.test(wechat)) {
      error = new Error('请输入正确的微信号');
    }

    if (error) {
      yield put(catchError(error));
      yield put(applyAgentCompletion(error));
      return;
    }

    const options = {
      url: '/api/audit4gift',
      method: 'POST',
      data: { realName, wechat },
    };
    const result = yield call(app.httpFetch, options);
    yield put(applyAgentCompletion(result.error, result.data));
  });
}

export function* watchUpgradeToAgent() {
  yield takeLatest('UPGRADE_TO_AGENT', function*() {
    const options = {
      url: '/api/user/qinPromoteJin',
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(upgradeToAgentCompletion(result.error, result.data));
  });
}

export function* watchLoadAgentInvoiceProxyRecord() {
  yield takeLatest('LOAD_AGENT_INVOICE_PROXY_RECORD', function*() {
    const options = {
      url: '/api/user/proxyRecord/get',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadAgentInvoiceProxyRecordCompletion(result.error, result.data));
  });
}

export function* watchLoadConsumeHistory() {
  yield takeLatest('LOAD_CONSUME_HISTORY', function*() {
    const options = {
      url: '/api/performance/spend',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadConsumeHistoryCompletion(result.error, result.data));
  });
}

export function* watchSaveAgentESignEdit() {
  yield takeLatest('SAVE_AGENT_E_SIGN_EDIT', function*() {
    const { code } = yield select(state => state.member.agent.eSign.input);
    let codeTrim = code.trim();

    if (!codeTrim) {
      const error = new Error('请输入验证码');
      yield put(catchError(error));
      yield put(saveAgentESignEditCompletion(error));
      return;
    }

    const result = yield call(app.httpFetch, {
      url: `/api/esign/sign/${codeTrim}`,
    });

    if (!result.error) {
      app
        .showConfirm({
          title: '签署成功',
          doneTitle: '确定',
          succIcon: true,
          message: '已成功为您调用数字证书并完成签署。',
          cancelable: false,
        })
        .then(res => {
          if (res.done) {
            app.redirectTo('/member/agent/esign/show');
            app.dispatch(saveAgentESignEditCompletion(result.error));
          }
        });
    } else {
      app.dispatch(saveAgentESignEditCompletion(result.error));
    }
  });
}

export default function* agentSaga() {
  yield all([
    fork(watchLoadMemberInfo),
    fork(watchLoadAgentInfo),
    fork(watchApplyAgent),
    fork(watchUpgradeToAgent),
    fork(watchLoadAgentInvoiceProxyRecord),
    fork(watchLoadConsumeHistory),
    fork(watchSaveAgentESignEdit),
  ]);
}
